import { useState } from "react";
import { Calendar, CircleCheck, Clock, ChevronDown, Plus, RefreshCw, Bell, Paperclip, Info,
    Undo2, Redo2, Strikethrough, Code2, Quote, ListOrdered, List, Link
 } from "lucide-react"



export default function EventModal({selectedDay, onClose}:{selectedDay: any, onClose: () => void}) {
    const [allDayEvent, setAllDayEvent] = useState(true);
      const [googleMeet, setGoogleMeet] = useState(false);
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-0">
              <div className="absolute inset-0 bg-black/40 transition-opacity" onClick={onClose} />
              <div className="bg-white dark:bg-gray-900 rounded-xl shadow-2xl w-full max-w-lg mx-auto flex flex-col relative max-h-[95vh] sm:max-h-[90vh] z-10 kt-fade-in-up">
                <div className="flex items-center gap-2 p-3 border-b border-gray-100 dark:border-gray-800 shrink-0 overflow-x-auto kt-scrollbar">
                  <button className="flex items-center gap-2 px-3 py-1.5 bg-blue-50 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 rounded-lg text-sm font-semibold transition-colors shrink-0">
                   <Calendar size={14}/> Sự kiện
                  </button>
                  <button className="flex items-center gap-2 px-3 py-1.5 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg text-sm font-medium transition-colors shrink-0">
                    <CircleCheck size={14}/> Cần làm
                  </button>
                  <button className="flex items-center gap-2 px-3 py-1.5 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg text-sm font-medium transition-colors shrink-0">
                    <Clock size={14}/> Nhắc lịch
                  </button>
                </div>
                <div className="flex-1 overflow-y-auto kt-scrollbar p-5 space-y-5">
                  <div>
                    <input
                      type="text"
                      placeholder="Thêm tiêu đề cho sự kiện này"
                      className="w-full text-2xl font-semibold text-gray-800 dark:text-gray-100 placeholder-gray-300 dark:placeholder-gray-600 border-b border-blue-400 dark:border-blue-600 focus:outline-none focus:border-blue-600 pb-2 bg-transparent"
                    />
                  </div>
                  <div className="bg-gray-50 dark:bg-gray-800 rounded-xl p-4 border border-gray-100 dark:border-gray-700 space-y-4">
                    <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                      <div className="flex-1">
                        <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 dark:text-gray-200 mb-1.5">
                          <Clock size={14} className="text-blue-500"/> Bắt đầu
                        </label>
                        <input
                          type="text"
                          defaultValue={selectedDay.format("dd, DD/MM/YYYY")}
                          className="w-full bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm text-gray-800 dark:text-gray-100 focus:outline-none focus:border-blue-500"
                        />
                      </div>
                      <div className="hidden sm:flex items-center justify-center pt-6">
                        <i className="ph ph-arrow-right text-gray-400 dark:text-gray-500" />
                      </div>
                      <div className="flex-1">
                        <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 dark:text-gray-200 mb-1.5">
                          <Clock size={14} className="text-yellow-500"/> Kết thúc
                        </label>
                        <input
                          type="text"
                          defaultValue={selectedDay.format("dd, DD/MM/YYYY")}
                          className="w-full bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm text-gray-800 dark:text-gray-100 focus:outline-none focus:border-blue-500"
                        />
                      </div>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between pt-3 border-t border-gray-200 dark:border-gray-700 gap-3">
                      <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400 cursor-pointer hover:text-gray-700 dark:hover:text-gray-200">
                        <div className="w-4 h-4 rounded bg-gray-200 dark:bg-gray-600" />
                        <span>Chọn loại sự kiện</span>
                        <ChevronDown size={14}/>
                      </div>
                      <div className="flex items-center justify-between sm:justify-start gap-3">
                        <span className="text-sm font-medium text-gray-700 dark:text-gray-200">Đây là một sự kiện cả ngày</span>
                        <button
                          onClick={() => setAllDayEvent((v) => !v)}
                          className={`w-10 h-6 rounded-full flex items-center px-1 cursor-pointer shrink-0 transition-colors ${allDayEvent ? "bg-green-500" : "bg-gray-200 dark:bg-gray-700"}`}
                        >
                          <div className={`w-4 h-4 bg-white rounded-full shadow-sm transition-transform ${allDayEvent ? "translate-x-2" : ""}`} />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="border-b border-gray-100 dark:border-gray-800 pb-4">
                    <label className="block text-sm font-semibold text-gray-800 dark:text-gray-100 mb-3">Người chủ trì</label>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-[#ab47bc] text-white flex items-center justify-center font-bold text-xs shadow-sm">H</div>
                      <button className="w-8 h-8 rounded-full border border-gray-300 dark:border-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors focus:outline-none">
                        <Plus size={16}/>
                      </button>
                    </div>
                  </div>
                  <div className="border-b border-gray-100 dark:border-gray-800 pb-4">
                    <label className="block text-sm font-semibold text-gray-800 dark:text-gray-100 mb-3">Người tham gia</label>
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-[#ab47bc] text-white flex items-center justify-center font-bold text-xs shadow-sm">H</div>
                      <button className="w-8 h-8 rounded-full border border-gray-300 dark:border-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors focus:outline-none">
                        <Plus size={16}/>
                      </button>
                    </div>
                  </div>
                  <div className="border-b border-gray-100 dark:border-gray-800 pb-4">
                    <label className="block text-sm font-semibold text-gray-800 dark:text-gray-100 mb-2">Mời qua Email</label>
                    <input
                      type="text"
                      placeholder="Nhập email khách mời..."
                      className="w-full bg-transparent border-none text-sm text-gray-800 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none"
                    />
                  </div>
                  <div className="border-b border-gray-100 dark:border-gray-800 pb-4 flex items-center justify-between">
                    <span className="text-sm font-semibold text-gray-800 dark:text-gray-100">Cuộc họp Google Meet</span>
                    <button
                      onClick={() => setGoogleMeet((v) => !v)}
                      className={`w-10 h-6 rounded-full flex items-center px-1 cursor-pointer shrink-0 transition-colors ${googleMeet ? "bg-green-500" : "bg-gray-200 dark:bg-gray-700"}`}
                    >
                      <div className={`w-4 h-4 bg-white rounded-full shadow-sm transition-transform ${googleMeet ? "translate-x-2" : ""}`} />
                    </button>
                  </div>
                  <div className="border-b border-gray-100 dark:border-gray-800 pb-4">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-semibold text-gray-800 dark:text-gray-100">Phòng họp</span>
                      <button className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 border border-gray-200 dark:border-gray-700 rounded-md text-xs font-semibold text-gray-700 dark:text-gray-200 transition-colors focus:outline-none">
                        <Plus size={14}/> Thêm
                      </button>
                    </div>
                    <span className="text-sm text-gray-500 dark:text-gray-400">Chưa có phòng họp</span>
                  </div>
                  <div className="flex flex-col sm:flex-row items-center gap-4 pt-2">
                    <div className="w-full sm:w-1/2 flex items-center justify-between px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                      <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-200">
                        <RefreshCw size={16} className="text-gray-400 dark:text-gray-500 text-lg"/>
                        Không lặp lại
                      </div>
                      <ChevronDown size={14} className="text-gray-400 dark:text-gray-500 text-xs"/>  
                    </div>
                    <div className="w-full sm:w-1/2 flex items-center justify-between px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                      <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-200">
                        <Bell size={16} className="text-gray-400 dark:text-gray-500 text-lg" />
                        Không nhắc trước
                      </div>
                       <ChevronDown size={14} className="text-gray-400 dark:text-gray-500 text-xs"/> 
                    </div>
                  </div>
                  <div className="pt-4 space-y-4">
                    <label className="block text-sm font-semibold text-gray-800 dark:text-gray-100">Nội dung cuộc họp</label>
                    <div className="border border-gray-200 dark:border-gray-700 rounded-md overflow-hidden">
                      <div className="bg-[#f8f9fa] dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-2 py-1.5 flex items-center gap-0.5 text-gray-500 dark:text-gray-400 overflow-x-auto kt-scrollbar">
                            {/* Undo / Redo */}
                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors shrink-0">
                                <Undo2 size={17} />
                            </button>

                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors shrink-0">
                                <Redo2 size={17} />
                            </button>

                            <div className="w-[1px] h-4 bg-gray-300 dark:bg-gray-600 mx-1.5 shrink-0" />

                            {/* Heading */}
                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors font-medium text-[15px] shrink-0">
                                H<sub className="text-[9px] font-bold">1</sub>
                            </button>

                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors font-medium text-[15px] shrink-0">
                                H<sub className="text-[9px] font-bold">2</sub>
                            </button>

                            <div className="w-[1px] h-4 bg-gray-300 dark:bg-gray-600 mx-1.5 shrink-0" />

                            {/* Bold */}
                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors font-bold text-base shrink-0">
                                B
                            </button>

                            {/* Italic */}
                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors italic font-serif text-base shrink-0">
                                I
                            </button>

                            {/* Strikethrough */}
                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors shrink-0">
                                <Strikethrough size={17} />
                            </button>

                            <div className="w-[1px] h-4 bg-gray-300 dark:bg-gray-600 mx-1.5 shrink-0" />

                            {/* Code */}
                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors shrink-0">
                                <Code2 size={17} />
                            </button>

                            {/* Quote */}
                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors shrink-0">
                                <Quote size={17} />
                            </button>

                            <div className="w-[1px] h-4 bg-gray-300 dark:bg-gray-600 mx-1.5 shrink-0" />

                            {/* Ordered list */}
                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors shrink-0">
                                <ListOrdered size={17} />
                            </button>

                            {/* Unordered list */}
                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors shrink-0">
                                <List size={17} />
                            </button>

                            <div className="w-[1px] h-4 bg-gray-300 dark:bg-gray-600 mx-1.5 shrink-0" />

                            {/* Link */}
                            <button className="w-8 h-8 flex items-center justify-center hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors shrink-0">
                                <Link size={17} />
                            </button>
                        </div>
                      <div className="bg-white dark:bg-gray-900 min-h-[120px]">
                        <textarea
                          className="w-full h-28 p-3 text-sm text-gray-800 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none resize-none bg-transparent"
                          placeholder="Nhập nội dung..."
                        />
                      </div>
                    </div>
                    <div className="h-2 bg-[#f4f5f7] dark:bg-gray-800 border-y border-gray-100 dark:border-gray-800 -mx-5 my-4" />
                    <div className="pt-1 pb-2 px-1">
                      <button className="flex items-center gap-2 text-[#41b871] hover:text-[#208f5a] dark:text-emerald-400 dark:hover:text-emerald-300 font-semibold text-sm transition-colors focus:outline-none">
                        <Paperclip size={14}/>
                        Thêm tệp đính kèm
                      </button>
                    </div>
                  </div>
                </div>
                <div className="p-4 border-t border-gray-100 dark:border-gray-800 flex flex-col sm:flex-row items-center justify-between bg-white dark:bg-gray-900 rounded-b-xl shrink-0 gap-4">
                  <div className="flex items-center gap-2 px-3 py-2 sm:py-1.5 bg-[#fef3c7] dark:bg-amber-900/40 text-[#b45309] dark:text-amber-300 rounded-md text-xs font-semibold w-full sm:w-auto justify-center">
                    <Info size={14}/> Không đồng bộ với Lịch Google
                  </div>
                  <div className="flex items-center justify-end gap-3 w-full sm:w-auto">
                    <button
                      onClick={onClose}
                      className="px-5 py-2 rounded-md bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-sm font-semibold text-gray-700 dark:text-gray-200 transition-colors focus:outline-none"
                    >
                      Hủy bỏ
                    </button>
                    <button
                      onClick={onClose}
                      className="px-5 py-2 rounded-md bg-[#254263] hover:bg-[#1a3048] text-sm font-semibold text-white transition-colors shadow-sm focus:outline-none"
                    >
                      Lưu
                    </button>
                  </div>
                </div>
              </div>
            </div>
    )
}